import Panel from 'beam/dist/Panel'
import { Grid } from '@mui/material'
import { useEnsuredUser } from '../../../Permissions/useEnsuredUser'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../root.reducer'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-Sentiment-'

export const AdvSentiment = ({ contactId, callDuration }: {contactId: number, callDuration: number}) => {
  const webUrl = useAppSelector(state => state.app.appProperties?.convIntelligenceWebUrl)
  const authHost = window.location.host
  const { t } = useTranslation()
  const user = useEnsuredUser()
  const sessionId = user.sessionId

  const iframeUrl = webUrl ? `${webUrl}/#/advSentiment/trendGraph?host=${authHost}&sid=${sessionId}&contactId=${contactId}&callDuration=${callDuration}` : null

  return (
    <Grid height={ '100%' }
    >
      {/* @ts-expect-error TODO: upgrade to beam-v11 */}
      <Panel
        dense
        title={t('aiSentiment')}
        variant="light"
        dataTestId={`${dataTestIdPrefix}panel`}
        headerTestId={`${dataTestIdPrefix}panel-heading`}
        titleIcon={<span />}
      >
        {iframeUrl
          ? <iframe title={t('aiSentiment')} src={ iframeUrl } width={ '100%' } height={ '100%' } style={ { 'border': 0 } } />
          : <div />
        }
      </Panel>
    </Grid>
  )
}
